import request from '@/utils/axios'
// 匹配申请
export function matchingAdd (params) {
  return request({
    url: '/api/cadd',
    method: 'post',
    params
  })
}
